import Gikam from '../core/gikam-core.js';
import tab from './template/tab.vue';
import Vue from 'vue';
import Base from "./base";

let defaultOptions = {
    renderTo: void 0,
    showIndex: 0,
    //组件高度，支持百分数、数字、像素字符串
    height: 'auto',
    panels: [],
    show: true,
    //允许的最大宽度，由父组件传值
    allowWidth: 0,
    //是否填充满父容器
    fill: false,
};

export default class Tab extends Base {

    constructor(props) {
        super();
        this.listeners = {
            rendered: Gikam.emptyFunction,
            actived: Gikam.emptyFunction
        };
        this.$window = props.$window;
        this.$children = [];
        this.$parent = null;
        this.initialize(props, defaultOptions).init(props);
    }

    createModel() {
        const _this = this;
        return new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            provide: {
                tab: this
            },
            render() {
                return <tab ref="vm" options={_this.options}></tab>;
            }
        });
    }

    createItems() {
        const panelBodyList = this.model.$refs.vm.$refs.panelBody;
        this.options.panels.forEach((tabPaneItem, index) => {
            if (!tabPaneItem.items) {
                tabPaneItem.items = [];
            }
            //只有一个子元素时，如果标签页是填充模式或者设置了高度，那么子元素为填充模式
            if (tabPaneItem.items.length === 1
                && (this.options.fill === true ||
                    (this.options.height && this.options.height !== 'auto'))) {
                tabPaneItem.items[0].fill = true;
            }
            tabPaneItem.items.forEach(item => {
                item.renderTo = panelBodyList[index];
                item.$window = this.$window;
                item.allowWidth = this.options.allowWidth || this.options.renderTo.clientWidth;
                const comp = Gikam.create(item.type, item);
                this.$children.push(comp);
                comp.$parent = this;
            });
        });
    }

    show() {
        this.model.$refs.vm.show = true;
    }


    hide() {
        this.model.$refs.vm.show = false;
    }

    removePanel(id) {
        this.model.$refs.vm.removePanel(id)
    }

    revertPanel(id) {
        this.model.$refs.vm.revertPanel(id)
    }

    showPanel(id) {
        this.model.$refs.vm.showPanel(id);
    }

    /**
     * @description 父组件尺寸变更时触发
     * @private 
     * @param
     * @memberof Tab
     */
    onResize() {
        this.$width = this.$parent.$width;
        this.$height = this.$parent.$height;
        this.$children.forEach(comp => {
            comp.onResize && comp.onResize();
        })
    }

    init() {
        this.model = this.createModel();
        this.bindInstance(this.model.$el);
        this.createItems();
        this.trigger('rendered');
    }

}